var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1147_28446)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "#E9EEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25784 -10.5123L8.25914 247.775C8.25916 251.157 11.0003 253.898 14.3816 253.898H184.505C187.886 253.898 190.627 251.157 190.627 247.775V5.91493C190.627 2.53359 187.886 -0.207523 184.505 -0.207523H87.1277C85.3162 -0.207523 83.5976 -1.00976 82.4343 -2.39845L72.3442 -14.4438C71.1809 -15.8325 69.4624 -16.6348 67.6508 -16.6348H14.3803C10.9989 -16.6348 8.25783 -13.8936 8.25784 -10.5123Z",
    fill: "#8AA6EE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1147_28446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.07007 30.2734C-2.17037 30.2734 -4.77086 32.9496 -4.6779 36.1887L1.44308 249.479C1.53234 252.59 4.07947 255.065 7.19105 255.065H194.812C197.942 255.065 200.498 252.561 200.561 249.431L204.882 36.1402C204.947 32.9195 202.354 30.2734 199.132 30.2734H193.46H21.3359H11.0902H1.07007Z",
    fill: "#1F57E7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1147_28446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.042 56.2087H106.959V73.1253H90.042V56.2087ZM90.042 90.042H106.959V140.792H90.042V90.042ZM98.5003 13.917C51.8103 13.917 13.917 51.8103 13.917 98.5003C13.917 145.19 51.8103 183.084 98.5003 183.084C145.19 183.084 183.084 145.19 183.084 98.5003C183.084 51.8103 145.19 13.917 98.5003 13.917ZM98.5003 166.167C61.1991 166.167 30.8337 135.802 30.8337 98.5003C30.8337 61.1991 61.1991 30.8337 98.5003 30.8337C135.802 30.8337 166.167 61.1991 166.167 98.5003C166.167 135.802 135.802 166.167 98.5003 166.167Z",
    fill: "#E9EEFD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1147_28446",
    x: -4.68066,
    y: 30.2734,
    width: 209.563,
    height: 232.954,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.16327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.08163
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.278431 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1147_28446"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1147_28446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1147_28446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 203,
    height: 203,
    fill: "white",
    transform: "translate(-3 -3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8560ae4cc127252b6bf6696cea541663.svg";
export { ForwardRef as ReactComponent };